<template>
  <div class="card__content">
    <div class="row">
      <div class="col-xs-12">
        <div class="table-responsive">
          <vue-good-table
            mode="remote"
            :columns="columns"
            :pagination-options="{
              enabled: true,
              perPage: 10,
              nextLabel: 'siguiente',
              prevLabel: 'anterior',
              rowsPerPageLabel: 'Registros por página',
              ofLabel: 'de',
              allLabel: 'Todo',
              dropdownAllowAll: true,
              perPageDropdownEnabled: true,
              perPageDropdown: [10, 20, 30, 40, 50]
            }"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            :totalRows="form.pagination.total"
            :rows="registros"
            :search-options="{
              enabled: false,
              placeholder: 'Buscar...'
            }"
            styleClass="vgt-table"
            :row-style-class="rowStyleClassFn"
          >
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label =='acciones'">
                Acciones
              </span>
              <span v-else>
                {{props.column.label}}
              </span>
            </template>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'contenido'">
                {{ props.row.contenido.substring(0, 50)+ '...' }}
              </span>
              <span v-else-if="props.column.field == 'acciones'">
                <button @click="botonDescargarPdf(props.row)" tooltip="Descargar PDF" class="btn-danger" type="button">
                  <i class="fa fa-file-pdf-o"></i>
                </button>
                <button @click="botonEditar(props.row)" tooltip="Editar" class="btn-info" type="button">
                  <i class="fa fa-edit"></i>
                </button>
                <button @click="botonEliminar(props.row)" :tooltip="props.row.estado == 'I'?'Re-activar':'Anular'" :class="props.row.estado == 'I'?'btn-success':'btn-danger'" type="button">
                  <i class="fa fa-trash"></i>
                </button>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propRegistros: {
      type: Array,
      required: false,
      default: function(){
        return [];
      }
    },
    propForm: {
      type: Object,
      required: false,
      default: function(){
        return {};
      }
    },
  },
  data() {
    return {
      columns: [
        {
          label: 'Contenido',
          field: 'contenido'
        },
        {
          label: 'Estado',
          field: 'nombre_estado'
        },
        {
          label: 'Fecha creación',
          field: 'created_at'
        },
        {
          label: 'acciones',
          field: 'acciones'
        }
      ],
      registros: this.propRegistros,
      form: this.propForm
    }
  },
  methods: {
    botonDescargarPdf: function(row){
      this.$emit('descargarPdf', row);
    },
    botonEditar: function(row){
      this.$emit('editar', row);
    },
    botonEliminar: function(row){
      this.$emit('eliminar', row);
    },
    onPageChange: function(param){
      this.$emit('consultar', param);
    },
    onPerPageChange: function(param){
      param = Object.assign({}, param, {dropdown: true});
      this.$emit('consultar', param);
    },
    rowStyleClassFn(row) {
      if(row.estado == 'I')
        return 'tr--canceled';
      return '';
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/terminos-condiciones/ListaTerminosCondiciones.vue